import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <div className="footer-root mt-6 text-center">
      <p className="text-sm text-gray-600">
        ¿Necesitas ayuda?{' '}
        <button
          type="button"
          aria-label="Abrir Mesa de Ayuda"
          onClick={() => {
            try { window.dispatchEvent(new Event('senerfi_helpdesk_open')); } catch (_) {}
          }}
          className="text-gray-600 hover:text-gray-700 font-medium"
        >
          Contacta Mesa de Ayuda
        </button>
      </p>
    </div>
  );
}
